.footer {
  border-top: 1px solid var(--border);
  padding: 1rem 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: var(--panel);
}

.row {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  font-size: 0.9rem;
  color: var(--muted);
  flex-wrap: wrap;
}

.row strong {
  color: var(--text);
}

.alert {
  background: var(--danger-bg);
  color: var(--danger);
  padding: 0.75rem 1rem;
  border-radius: 8px;
  font-size: 0.9rem;
}

.batteryCell {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
}
